import { CustomError } from 'utils/customError'

const basePath = '/guru/skp'

const paths = {
  basePath,
  guru: `${basePath}/v1`,
  commonConfig: `${basePath}/v1/pelaksanaan/static-config`,
  kinerja: `${basePath}/v1/ks/perencanaan-skp`,
  konten: `${basePath}/v1/ks/konten`,
  realisasiSkp: `${basePath}/v1/ks/realisasi-skp`,
  pelaksanaan: `${basePath}/v1/ks/pelaksanaan`,
  pengawasSekolah: `${basePath}/v1/ks/ps`,
  buktiDukung: `${basePath}/v1/ks/bukti-dukung`,
  mediaManager: `${basePath}/v1/media-manager`,
  dinas: `${basePath}/v1/ks/dinas`,
  penilaian: `${basePath}/v1/ks/penilaian`,
  atasan: `${basePath}/v1/ks/atasan`,
  riwayat: `${basePath}/v1/ks/riwayat-skp`,
  riwayatGuru: `${basePath}/v1/riwayat-skp`,
  ekin: `${basePath}/v1/ekin`,
}

export const apiPaths = {
  ...paths,
  perencanaanPengawasSekolah: `${paths.pengawasSekolah}/perencanaan-skp`,
  pelaksanaanPengawasSekolah: `${paths.pengawasSekolah}/pelaksanaan`,
  penilaianPengawasSekolah: `${paths.pengawasSekolah}/penilaian`,
  realisasiSkpPengawasSekolah: `${paths.pengawasSekolah}/realisasi-skp`,
  buktiDukungPengawasSekolah: `${paths.pengawasSekolah}/bukti-dukung`,
  kontenPengawasSekolah: `${paths.pengawasSekolah}/konten`,
  perencanaanDinas: `${paths.dinas}/perencanaan-skp`,
  pelaksanaanDinas: `${paths.dinas}/pelaksanaan`,
  kontenDinas: `${paths.dinas}/konten`,
  penilaianDinas: `${paths.dinas}/penilaian`,
  penilaianTahunanDinas: `${paths.dinas}/yearly-skp`,

  guruPerencanaanPltKsDinas: `${paths.guru}/dinas/perencanaan-skp`,
  guruPenilaianPltKsPengawasSekolah: `${paths.guru}/ps/penilaian/plt-ks`,
  guruPenilaianPltKsDinas: `${paths.guru}/dinas/penilaian/plt-ks`,
  guruPenilaianTahunanPltKsDinas: `${paths.guru}/dinas/predikat-kinerja/annual`,

  guruPredikatKinerjaPltKs: `${paths.guru}/ps/predikat-kinerja/plt-ks`,
}

export const queryKeyWithNpsn = (querykey: string, npsn?: any) => {
  return [querykey, ...(!!npsn ? [npsn] : [])]
}

export class InvalidUserNoAccess extends CustomError {
  constructor(apiPath: string, originalError: any) {
    const title =
      'Saat ini halaman baru tersedia untuk Guru, Kepala Sekolah, Tim Kerja (Pengawas Sekolah), dan Dinas Pendidikan'
    const description =
      'Untuk Guru dan Kepala Sekolah, pastikan data "Jenis PTK" di Dapodik sesuai. Untuk Tim Kerja dan Dinas Pendidikan, pastikan data di Simtendik sesuai.'
    super({ title, description, apiPath, originalError })
  }
}

export class InvalidUserNoAccessPelaksanaan extends CustomError {
  constructor(apiPath: string, originalError: any) {
    const title = 'Halaman belum tersedia untuk Anda'
    const description =
      'Halaman ini sedang kami persiapkan agar dapat segera hadir untuk Anda. Jika ada kendala, silakan kunjungi Pusat Bantuan.'
    super({ title, description, apiPath, originalError })
  }
}

export class PenetapanNotAllowed extends CustomError {
  constructor(apiPath: string, originalError: any) {
    const title = 'Penetapan untuk periode ini belum dapat dilakukan'
    const description =
      'Cek lagi halaman ini nanti, ya. Kunjungi Pusat Bantuan untuk selengkapnya.'
    super({ title, description, apiPath, originalError })
  }
}
